import { enablePointerEvents } from '@utils/pointer-events-control';
let card1 = null;
let card2 = null;
let card3 = null;
let card4 = null;
let card5 = null;
let zone_1 = null;
let hand = null;
let cPoints = null;
let cPoints1 = null;
let cPoints2 = null;
let cPoints3 = null;
let cPoints4 = null;
let cPoints5 = null;
let cPoints6 = null;

let seq = [];
let cardOrginals = [];

let cardvalue = null;

let cardDrop = -1;
//var cardsaudio
let bottomcards = [];

let availables = [0, 1, 2, 3, 4];

import { config, gameState } from '@js/state';

export default class GameScene extends Phaser.Scene {
  constructor() {
    super({
      key: 'GameScene',
    });
  }

  preload() {
    this.load.video('driveout', 'assets/GameSceneAssets/HYPERDRIVE_end.mp4');

    for (let i = 1; i <= 5; i++) {
      for (let j = -1; j <= 9; j++) {
        //this.load.image(j+"_"+i, "assets/GameSceneAssets/"+j+"_"+i+".png");
        this.load.image(
          j + '_' + i + 'c',
          'assets/GameSceneAssets/' + j + '_' + i + 'c.png',
        );
        this.load.image(
          j + '_' + i + 'w',
          'assets/GameSceneAssets/' + j + '_' + i + 'w.png',
        );
      }
    }
  }

  create() {
    // Enable pointer events so hover states and the cursor work
    enablePointerEvents();

    //this.qseq = [1,]

    seq = [];
    cardOrginals = [];
    gameState.cam = null;
    cardvalue = null;

    cardDrop = -1;

    bottomcards = [];

    availables = [0, 1, 2, 3, 4];

    this.cardhaudio = this.sound.add('cardhaudio').setVolume(0.1);
    this.carddaudio = this.sound.add('carddaudio').setVolume(0.1);

    this.cardp = this.sound.add('cardp').setVolume(0.25);
    this.cardsaudio = this.sound.add('cardsaudio').setVolume(0.1);
    this.caudio = this.sound.add('caudio').setVolume(0.1);
    this.waudio = this.sound.add('waudio').setVolume(0.1);
    this.video1audio = this.sound.add('video1audio').setVolume(0.1);
    this.video2audio = this.sound.add('video2audio').setVolume(0.1);

    const r5 = this.add
      .rectangle(0, 0, 1280, 720, 0xffffff)
      .setOrigin(0)
      .setDepth(15)
      .setAlpha(1);

    this.tweens.add({
      targets: r5,
      alpha: 0,
      duration: 500,
      ease: 'Sine.easeInOut',
    });

    this.scene.launch('HintScene');

    this.checktest = false;
    // this.gbg = this.add.image(640,100,'bg').setOrigin(0.5,100/720)

    this.positions = [0, 1, 2, 3, 4];

    //this.positions = [4,3,2,1,0]

    //    var r5 = this.add.rectangle(0, 0,1280,720, 0x000000).setOrigin(0);

    this.vid = this.add.video(0, 0, 'drivein').setOrigin(0).setMute(true);
    this.vid.play();
    this.vid.once('play', () => {
      this.vid.stop();
    });
    //this.vid.setCurrentTime(1)

    this.bg = this.add
      .image(640, 56.01 + 100, 'A1')
      .setOrigin(0.5, 100 / 442.98)
      .setAlpha(0);

    this.vid2 = this.add.video(0, 0, 'driveout').setOrigin(0).setAlpha(0);

    this.check = this.add
      .image(567, 916, 'check')
      .setOrigin(0)
      .setDepth(10)
      .setInteractive({ cursor: 'pointer' });

    this.nextQ = this.add
      .image(523, 947, 'nextQ')
      .setOrigin(0)
      .setDepth(10)
      .setInteractive({ cursor: 'pointer' });

    this.lightbar = this.add.image(640, 16, 'lightbar').setOrigin(0.5, 0).setDepth(1);

    this.green1 = this.add
      .image(507 - 10, 20.5, 'green')
      .setOrigin(0, 0)
      .setDepth(2)
      .setAlpha(0);
    this.green2 = this.add
      .image(555 - 10, 20.5, 'green')
      .setOrigin(0, 0)
      .setDepth(2)
      .setAlpha(0);
    this.green3 = this.add
      .image(603 - 10, 20.5, 'green')
      .setOrigin(0, 0)
      .setDepth(2)
      .setAlpha(0);
    this.green4 = this.add
      .image(651 - 10, 20.5, 'green')
      .setOrigin(0, 0)
      .setDepth(2)
      .setAlpha(0);
    this.green5 = this.add
      .image(699 - 10, 20.5, 'green')
      .setOrigin(0, 0)
      .setDepth(2)
      .setAlpha(0);
    this.green6 = this.add
      .image(747 - 10, 20.5, 'green')
      .setOrigin(0, 0)
      .setDepth(2)
      .setAlpha(0);

    this.nextQ.on('pointerdown', () => {
      this.tweens.add({
        targets: this.nextQ,
        y: 947,
        ease: 'Power2',
        duration: 500,
        repeat: 0,
        onComplete: () => {},
      });

      this.tweens.add({
        targets: this.pushbutton,
        x: 862,
        y: 622,
        ease: 'sine.easeOut',
        duration: 500,
        delay: 300,
        //delay:this.cardDisplayDelay + 130*this.positions[i],
        repeat: 0,
        onComplete: () => {
          this.tweens.add({
            targets: this.stick,
            angle: 120,
            ease: 'sine.easeOut',
            duration: 500,
            //delay:this.cardDisplayDelay + 130*this.positions[i],
            repeat: 0,
          });
        },
      });

      this.tweens.add({
        targets: this.stick,
        angle: 0,
        ease: 'sine.easeOut',
        duration: 500,
        delay: 1500,
        //delay:this.cardDisplayDelay + 130*this.positions[i],
        repeat: 0,
      });

      this.tweens.add({
        targets: this.pushbutton,
        x: 870,
        y: 663,
        ease: 'sine.easeOut',
        duration: 500,
        delay: 1500,
        //delay:this.cardDisplayDelay + 130*this.positions[i],
        repeat: 0,
      });

      this.tweens.add({
        targets: this.bg,
        scale: 1.5,
        ease: 'sine.easeOut',
        duration: 1500,
        delay: 1000,
        //delay:this.cardDisplayDelay + 130*this.positions[i],
        repeat: 0,
      });

      this.tweens.add({
        targets: this.bg,
        alpha: 0,
        ease: 'sine.easeOut',
        duration: 1000,
        delay: 1000,
        //delay:this.cardDisplayDelay + 130*this.positions[i],
        repeat: 0,
      });

      // this.vid.changeSource('driveout')

      this.tweens.add({
        targets: this.vid2,
        alpha: 1,
        ease: 'sine.easeOut',
        duration: 800,
        delay: 1000,
        //delay:this.cardDisplayDelay + 130*this.positions[i],
        repeat: 0,
        onStart: () => {
          this.vid2.play();
          this.video2audio.play();
        },
      });

      this.tweens.add({
        targets: [this.C0, this.C1, this.C2, this.C3, this.C4, this.C5, this.C6],
        alpha: 0,
        ease: 'sine.easeOut',
        duration: 500,
        delay: 1500,
        //delay:this.cardDisplayDelay + 130*this.positions[i],
        repeat: 0,
      });

      this.time.delayedCall(
        4500,
        () => {
          gameState.attempts = 0;
          gameState.qnum++;

          this.nextquestions();
        },
        this,
      );
    });

    this.check.on('pointerdown', () => {
      if (gameState.qnum == -1 && gameState.attempts == 0 && !gameState.retry) {
        for (let k = 2; k <= 6; k++) {
          this.load.image('A' + k, 'assets/GameSceneAssets/A' + k + '.png');
        }
        this.load.start();
      }
      this.box.setAlpha(0);
      this.overlay.setAlpha(0);
      this.overlay2.setAlpha(0);
      this.carrow.setAlpha(0);
      this.T4.setAlpha(0);
      this.T2.setAlpha(0);

      this.checktest = false;
      this.tweens.add({
        targets: this.check,
        y: 916,
        ease: 'Power2',
        duration: 500,
        repeat: 0,
      });

      if (
        card1.x < card2.x &&
        card2.x < card3.x &&
        card3.x < card4.x &&
        card4.x < card5.x &&
        card5.x == 840
      ) {
        this.caudio.play();

        gameState.hintClose = true;
        gameState.correct++;
        if (gameState.correct == 1) {
          this.green1.setAlpha(1);
        } else if (gameState.correct == 2) {
          this.green2.setAlpha(1);
        } else if (gameState.correct == 3) {
          this.green3.setAlpha(1);
        } else if (gameState.correct == 4) {
          this.green4.setAlpha(1);
        } else if (gameState.correct == 5) {
          this.green5.setAlpha(1);
        } else if (gameState.correct == 6) {
          this.green6.setAlpha(1);
        }

        for (let i = 0; i <= 4; i++) {
          this.cards[i].disableInteractive();
          //bottomcards[1].setTexture(gameState.gameState.qnum+"_"+(this.positions[1]+1)+"c")
        }

        bottomcards[0].setTexture(gameState.qnum + '_' + (this.D1 + 1) + 'c');
        bottomcards[1].setTexture(gameState.qnum + '_' + (this.D2 + 1) + 'c');
        bottomcards[2].setTexture(gameState.qnum + '_' + (this.D3 + 1) + 'c');
        bottomcards[3].setTexture(gameState.qnum + '_' + (this.D4 + 1) + 'c');
        bottomcards[4].setTexture(gameState.qnum + '_' + (this.D5 + 1) + 'c');

        this.tweens.add({
          targets: this.pushbutton,
          x: 862,
          y: 622,
          ease: 'sine.easeOut',
          duration: 500,
          //delay:this.cardDisplayDelay + 130*this.positions[i],
          repeat: 0,
          onComplete: () => {
            this.tweens.add({
              targets: this.stick,
              angle: 120,
              ease: 'sine.easeOut',
              duration: 500,
              //delay:this.cardDisplayDelay + 130*this.positions[i],
              repeat: 0,

              onComplete: () => {
                //this.vid.changeSource('drivein')
                this.tweens.add({
                  targets: this.vid2,
                  alpha: 0,
                  ease: 'sine.easeOut',
                  duration: 150,
                  //delay:this.cardDisplayDelay + 130*this.positions[i],
                  repeat: 0,
                });

                this.vid.play().setAlpha(1);
                this.video1audio.play();

                this.bg.setTexture('A' + gameState.correct).setAlpha(0);
                this.bg.setScale(1.1);

                this.tweens.add({
                  targets: this.stick,
                  angle: 0,
                  ease: 'sine.easeOut',
                  duration: 500,
                  delay: 2500,
                  //delay:this.cardDisplayDelay + 130*this.positions[i],
                  repeat: 0,
                });

                this.tweens.add({
                  targets: this.pushbutton,
                  x: 870,
                  y: 663,
                  ease: 'sine.easeOut',
                  duration: 500,
                  delay: 2500,
                  //delay:this.cardDisplayDelay + 130*this.positions[i],
                  repeat: 0,
                });

                this.tweens.add({
                  targets: this.bg,
                  alpha: 1,
                  ease: 'sine.easeIn',
                  duration: 700,
                  delay: 3500,
                  //delay:this.cardDisplayDelay + 130*this.positions[i],
                  repeat: 0,
                  onStart: () => {
                    this.vid.setAlpha(0);

                    this.tweens.add({
                      targets: this.bg,
                      scale: 1,
                      ease: 'sine.easeOut',
                      duration: 500,
                      delay: 200,
                      //delay:this.cardDisplayDelay + 130*this.positions[i],
                      repeat: 0,
                    });
                  },

                  onComplete: () => {
                    if (gameState.correct == 6 || gameState.qnum == 9) {
                      if (gameState.correct == 6) {
                        gameState.gameWin = true;
                      } else {
                        gameState.gameWin = false;
                      }
                      gameState.cam = this.cameras.main;

                      this.time.delayedCall(
                        2500,
                        () => {
                          config.audio.bgAudio.setVolume(0);
                          this.scene.launch('EndScene');
                          this.scene.pause('GameScene');
                        },
                        this,
                      );
                    } else {
                      this.tweens.add({
                        targets: this.nextQ,
                        y: 647,
                        ease: 'Power2',
                        duration: 500,
                        delay: 500,
                        repeat: 0,
                        onComplete: () => {},
                      });
                    }
                  },
                });

                this.flipstart = 500;

                this.flipdelay = 200;

                this.flipping(cPoints, this.C0, 300, 0, 0, 1);
                this.flipping(cPoints1, this.C1, 300 + 1 * this.flipdelay, 2, 2, 2);
                this.flipping(cPoints2, this.C2, 300 + 2 * this.flipdelay, 4, 4, 3);
                this.flipping(cPoints3, this.C3, 300 + 3 * this.flipdelay, 6, 6, 4);
                this.flipping(cPoints4, this.C4, 300 + 4 * this.flipdelay, 8, 8, 5);
                this.flipping(cPoints5, this.C5, 300 + 5 * this.flipdelay, 10, 10, 6);
                this.flipping(cPoints6, this.C6, 300 + 6 * this.flipdelay, 12, 12, 7);

                this.time.delayedCall(
                  300,
                  () => {
                    this.cardsaudio.play();
                  },
                  [],
                  this,
                );
              },
            });
          },
        });
      } else {
        this.waudio.play();
        gameState.attempts++;

        for (let i = 0; i <= 4; i++) {
          this.cards[i].disableInteractive();
          //this.cards[i].setTexture(gameState.qnum+"_"+(i+1)+"w")
          this.cards[i];
        }

        bottomcards[0].setTexture(gameState.qnum + '_' + (this.D1 + 1) + 'w');
        bottomcards[1].setTexture(gameState.qnum + '_' + (this.D2 + 1) + 'w');
        bottomcards[2].setTexture(gameState.qnum + '_' + (this.D3 + 1) + 'w');
        bottomcards[3].setTexture(gameState.qnum + '_' + (this.D4 + 1) + 'w');
        bottomcards[4].setTexture(gameState.qnum + '_' + (this.D5 + 1) + 'w');

        this.time.delayedCall(
          2000,
          () => {
            if (gameState.attempts < 3) {
              gameState.hneed = true;
              availables = [0, 1, 2, 3, 4];
              for (let i = 0; i <= 4; i++) {
                this.cards[i].setTexture(gameState.qnum + '_' + (i + 1));
                this.cards[i].x = cardOrginals[2 * i];

                //this.cards[i].setInteractive()

                //
                this.tweens.add({
                  targets: bottomcards[i],
                  alpha: 0,
                  ease: 'Power2',
                  duration: 400,
                  delay: () => {
                    if (i == 0 || i == 4) {
                      return 300;
                    } else if (i == 1 || i == 3) {
                      return 150;
                    } else {
                      return 0;
                    }
                  },
                  repeat: 0,
                  onComplete: () => {
                    //this.cards[i].setAlpha(0)
                  },
                });

                this.tweens.add({
                  targets: this.cards[i],

                  alpha: 1,
                  ease: 'Power2',
                  duration: 200,
                  delay: () => {
                    if (this.positions[i] == 0 || this.positions[i] == 4) {
                      return 400 + 200;
                    } else if (this.positions[i] == 1 || this.positions[i] == 3) {
                      return 400 + 100;
                    } else {
                      return 400;
                    }
                  },
                  repeat: 0,
                  onStart: () => {
                    this.cards[i].y = 300;
                  },
                });

                this.tweens.add({
                  targets: this.cards[i],
                  y: {
                    getEnd: function () {
                      return 330;
                    },
                    getStart: function () {
                      return 300;
                    },
                  },

                  ease: 'Power2',
                  duration: 200,
                  delay: () => {
                    if (this.positions[i] == 0 || this.positions[i] == 4) {
                      return 700 + 300;
                    } else if (this.positions[i] == 1 || this.positions[i] == 3) {
                      return 700 + 150;
                    } else {
                      return 700;
                    }
                  },
                  repeat: 0,
                  onComplete: () => {
                    this.cards[i].setInteractive();
                  },
                });
              }
            } else {
              this.tweens.add({
                targets: [this.C0, this.C1, this.C2, this.C3, this.C4, this.C5, this.C6],
                alpha: 0,
                ease: 'sine.easeOut',
                duration: 500,
                //delay:this.cardDisplayDelay + 130*this.positions[i],
                repeat: 0,
                onComplete: () => {
                  if (gameState.qnum == 9) {
                    gameState.cam = this.cameras.main;
                    gameState.gameWin = false;
                    config.audio.bgAudio.setVolume(0);
                    this.scene.launch('EndScene');
                    this.scene.pause('GameScene');
                  } else {
                    gameState.attempts = 0;
                    gameState.qnum++;
                    this.nextquestions();
                  }
                },
              });
            }
          },
          this,
        );
      }
    });

    this.check.on(
      'pointerover',
      function (_pointer) {
        this.check.setTexture('check_h');
        //this.scene.pause("GameLoadScene");
      },
      this,
    );

    this.check.on(
      'pointerout',
      function (_pointer) {
        this.check.setTexture('check');
        //this.scene.resume("GameLoadScene");
      },
      this,
    );

    this.nextQ.on(
      'pointerover',
      function (_pointer) {
        this.nextQ.setTexture('nextQh');
        //this.scene.pause("GameLoadScene");
      },
      this,
    );

    this.nextQ.on(
      'pointerout',
      function (_pointer) {
        this.nextQ.setTexture('nextQ');
        //this.scene.resume("GameLoadScene");
      },
      this,
    );
    //
    this.add.image(0, 0, 'ship').setOrigin(0);

    zone_1 = this.add.zone(640, 570, 550, 300).setRectangleDropZone(550, 300);

    //   card1 =  this.add.quad(429 +106*this.positions[0],330+300,gameState.qnum+'_1',null, {hideCCW: false,rtl: false,}).setInteractive({ cursor: "pointer" })

    //card1 = this.add.rexQuadImage(429 +106*this.positions[0],330+300, gameState.qnum+'_1',null,{
    //  hideCCW: true,
    //  rtl: true
    //}).setInteractive({ cursor: "pointer" });

    //card2 = this.add.rexQuadImage(429 +106*this.positions[1],330+300, gameState.qnum+'_1',null);

    // card2 = this.add.quad(429 +106*this.positions[1],330+300,gameState.qnum+'_2',null, {hideCCW: false,rtl: false,}).setInteractive({ cursor: "pointer" })

    seq = [-5, -3, -2, 0, 1];

    card5 = this.add
      .sprite(429 + 106 * this.positions[4], 330 + 300, gameState.qnum + '_5')
      .setInteractive({ cursor: 'pointer', pixelPerfect: true })
      .setDepth(1);

    card4 = this.add
      .sprite(429 + 106 * this.positions[3], 330 + 300, gameState.qnum + '_4')
      .setInteractive({ cursor: 'pointer', pixelPerfect: true })
      .setDepth(1);

    card3 = this.add
      .sprite(429 + 106 * this.positions[2], 330 + 300, gameState.qnum + '_3')
      .setInteractive({ cursor: 'pointer', pixelPerfect: true })
      .setDepth(1);

    card2 = this.add
      .sprite(429 + 106 * this.positions[1], 330 + 300, gameState.qnum + '_2')
      .setInteractive({ cursor: 'pointer', pixelPerfect: true })
      .setDepth(1);

    card1 = this.add
      .sprite(429 + 106 * this.positions[0], 330 + 300, gameState.qnum + '_1')
      .setInteractive({ cursor: 'pointer', pixelPerfect: true })
      .setDepth(1);

    cardOrginals = [
      card1.x,
      card1.y - 300,
      card2.x,
      card2.y - 300,
      card3.x,
      card3.y - 300,
      card4.x,
      card4.y - 300,
      card5.x,
      card5.y - 300,
    ];

    this.cards = [card1, card2, card3, card4, card5];

    //console.log(card1.controlPoints);

    //   this.input.setDraggable(card1)

    this.shipOverlay = this.add
      .image(0, 0, 'ship')
      .setOrigin(0)
      .setCrop(0, 394.5, 1280, 720 - 394.5)
      .setDepth(2);
    this.overlay = this.add.image(0, 0, 'overlay').setOrigin(0).setDepth(1);

    this.overlay2 = this.add
      .image(0, 0, 'overlay')
      .setOrigin(0)
      .setCrop(0, 394.5, 1280, 720 - 394.5)
      .setDepth(3);

    this.stickx = 5;
    this.sticky = 3;
    this.stick = this.add
      .image(766.5 - this.stickx, 611 + 40 - this.sticky, 'stick')
      .setOrigin(this.stickx / 23, 1 - this.sticky / 50)
      .setDepth(2);

    this.pushbutton = this.add.image(870, 663, 'pushbutton').setOrigin(0).setDepth(2);

    this.T1 = this.add.image(434, 280, 'T1').setOrigin(0).setDepth(7);
    this.T2 = this.add.image(640, 160, 'T2').setOrigin(0.5, 0).setDepth(7).setAlpha(0);

    this.time.delayedCall(
      500,
      () => {
        this.T1audio = this.sound.add('T1audio').setVolume(0.1).play();

        if (gameState.retry == false) {
          this.load.multiatlas(
            'baseCircle',
            'assets/anims/rewardAnims/baseCircleAnim.json',
            'assets/anims/rewardAnims/',
          );
          this.load.multiatlas(
            'glitter',
            'assets/anims/rewardAnims/glitterAnim.json',
            'assets/anims/rewardAnims/',
          );

          this.load.start();
        }
      },
      this,
    );

    //this.L0 = this.add.image(288-2 + 66,458-2+70.5 ,'L0').setOrigin(0.5).setDepth(2).setAlpha(0).setScale(0)
    this.L1 = this.add
      .image(381 - 2, 458 - 2, 'L1')
      .setOrigin(0)
      .setDepth(2)
      .setAlpha(0)
      .setInteractive({ cursor: 'pointer', pixelPerfect: true });
    this.L2 = this.add
      .image(474 - 2, 458 - 2, 'L2')
      .setOrigin(0)
      .setDepth(2)
      .setAlpha(0)
      .setInteractive({ cursor: 'pointer', pixelPerfect: true });
    this.L3 = this.add
      .image(568 - 2, 458 - 2, 'L3')
      .setOrigin(0)
      .setDepth(2)
      .setAlpha(0)
      .setInteractive({ cursor: 'pointer', pixelPerfect: true });
    this.L4 = this.add
      .image(661 - 2, 458 - 2, 'L4')
      .setOrigin(0)
      .setDepth(2)
      .setAlpha(0)
      .setInteractive({ cursor: 'pointer', pixelPerfect: true });
    this.L5 = this.add
      .image(754 - 1, 458 - 2, 'L5')
      .setOrigin(0)
      .setDepth(2)
      .setAlpha(0)
      .setInteractive({ cursor: 'pointer', pixelPerfect: true });
    //this.L6 = this.add.image(849+91.5,458-2+70.5,'L6').setOrigin(0.5).setDepth(2).setAlpha(0).setScale(0)

    //   this.C0 = this.add.text(332.34+ 20, 492+30, "-7", { fontFamily: "font1", fontSize: "33.65px", fill: "#000000" }).setOrigin(0.5, 0.5).setDepth(3).setAngle(3.2).setAlpha(0).setScale(0);
    //   this.C1 = this.add.text(332.34+ 18 +96.27, 492+30, "-5", { fontFamily: "font1", fontSize: "33.65px", fill: "#000000" }).setOrigin(0.5, 0.5).setDepth(6).setAngle(3.2*(2/3)).setAlpha(0);
    //   this.C2 = this.add.text(332.34+ 20 +2*96.27, 492+30, "-3", { fontFamily: "font1", fontSize: "33.65px", fill: "#000000" }).setOrigin(0.5, 0.5).setDepth(6).setAngle(3.2*(1/3)).setAlpha(0);
    //   this.C3 = this.add.text(332.34+ 20 +3*96.27, 492+30, "-2", { fontFamily: "font1", fontSize: "33.65px", fill: "#000000" }).setOrigin(0.5, 0.5).setDepth(6).setAngle(3.2*(0/3)).setAlpha(0);
    //   this.C4 = this.add.text(332.34+ 25 +4*96.27, 492+30, "0", { fontFamily: "font1", fontSize: "33.65px", fill: "#000000" }).setOrigin(0.5, 0.5).setDepth(6).setAngle(-3.2*(1/3)).setAlpha(0);
    //   this.C5 = this.add.text(332.34+ 25 +5*96.27, 492+30, "1", { fontFamily: "font1", fontSize: "33.65px", fill: "#000000" }).setOrigin(0.5, 0.5).setDepth(6).setAngle(-3.2*(2/3)).setAlpha(0);
    //   this.C6 = this.add.text(910+ 30, 492+30, "2", { fontFamily: "font1", fontSize: "33.65px", fill: "#000000" }).setOrigin(0.5, 0.5).setDepth(3).setAngle(-3.2).setAlpha(0).setScale(0);

    //   this.C1 = this.add.rexQuadImage(x, y, "A_1_1", null, {hideCCW: false,rtl: true,})

    this.midpoints = [
      363.065, 338.255, 455.87, 438.62, 549.62, 540.12, 643.37, 642.12, 736.87, 744.12,
      830.12, 845.37, 925.12, 949.87,
    ];

    this.gaps = [
      47.5,
      51,
      46.25 + 1,
      50 + 1,
      47 + 1,
      51 + 1,
      46.75 + 1,
      51 + 1,
      47.25,
      51.5,
      47.5,
      51.25,
      47.5 + 1.5,
      53.25 + 1.5,
    ];

    this.topYval = 455; //457
    //this.botYval = 594.52
    this.botYval = 597.52;
    this.C0 = this.add
      .rexQuadImage(417.13, this.topYval, gameState.qnum + '_0', null, {
        hideCCW: false,
        rtl: true,
      })
      .setDepth(4)
      .setAlpha(0);

    cPoints = this.C0.controlPoints;
    cPoints[0].setPosition(this.midpoints[0] - this.gaps[0], this.topYval);

    cPoints[1].setPosition(this.midpoints[0] + this.gaps[0], this.topYval);

    cPoints[2].setPosition(this.midpoints[1] - this.gaps[1], this.botYval);

    cPoints[3].setPosition(this.midpoints[1] + this.gaps[1], this.botYval);

    this.C1 = this.add
      .rexQuadImage(417.13, this.topYval, gameState.qnum + '_1', null, {
        hideCCW: false,
        rtl: true,
      })
      .setDepth(4)
      .setAlpha(0);

    //this.C1.setTexture('A_1_5')
    cPoints1 = this.C1.controlPoints;
    cPoints1[0].setPosition(this.midpoints[2] - this.gaps[2], this.topYval);

    cPoints1[1].setPosition(this.midpoints[2] + this.gaps[2], this.topYval);

    cPoints1[2].setPosition(this.midpoints[3] - this.gaps[3], this.botYval);

    cPoints1[3].setPosition(this.midpoints[3] + this.gaps[3], this.botYval);

    this.C2 = this.add
      .rexQuadImage(417.13, this.topYval, gameState.qnum + '_1', null, {
        hideCCW: false,
        rtl: true,
      })
      .setDepth(4)
      .setAlpha(0);

    //this.C1.setTexture('A_1_5')
    cPoints2 = this.C2.controlPoints;
    cPoints2[0].setPosition(this.midpoints[4] - this.gaps[4], this.topYval);

    cPoints2[1].setPosition(this.midpoints[4] + this.gaps[4], this.topYval);

    cPoints2[2].setPosition(this.midpoints[5] - this.gaps[5], this.botYval);

    cPoints2[3].setPosition(this.midpoints[5] + this.gaps[5], this.botYval);

    this.C3 = this.add
      .rexQuadImage(417.13, this.topYval, gameState.qnum + '_1', null, {
        hideCCW: false,
        rtl: true,
      })
      .setDepth(4)
      .setAlpha(0);

    //this.C1.setTexture('A_1_5')
    cPoints3 = this.C3.controlPoints;

    cPoints3[0].setPosition(this.midpoints[6] - this.gaps[6], this.topYval);

    cPoints3[1].setPosition(this.midpoints[6] + this.gaps[6], this.topYval);

    cPoints3[2].setPosition(this.midpoints[7] - this.gaps[7], this.botYval);

    cPoints3[3].setPosition(this.midpoints[7] + this.gaps[7], this.botYval);

    this.C4 = this.add
      .rexQuadImage(417.13, this.topYval, gameState.qnum + '_1', null, {
        hideCCW: false,
        rtl: true,
      })
      .setDepth(4)
      .setAlpha(0);

    //this.C1.setTexture('A_1_5')
    cPoints4 = this.C4.controlPoints;

    cPoints4[0].setPosition(this.midpoints[8] - this.gaps[8], this.topYval);

    cPoints4[1].setPosition(this.midpoints[8] + this.gaps[8], this.topYval);

    cPoints4[2].setPosition(this.midpoints[9] - this.gaps[9], this.botYval);

    cPoints4[3].setPosition(this.midpoints[9] + this.gaps[9], this.botYval);

    this.C5 = this.add
      .rexQuadImage(417.13, this.topYval, gameState.qnum + '_1', null, {
        hideCCW: false,
        rtl: true,
      })
      .setDepth(4)
      .setAlpha(0);

    //this.C1.setTexture('A_1_5')
    cPoints5 = this.C5.controlPoints;
    cPoints5[0].setPosition(this.midpoints[10] - this.gaps[10], this.topYval);

    cPoints5[1].setPosition(this.midpoints[10] + this.gaps[10], this.topYval);

    cPoints5[2].setPosition(this.midpoints[11] - this.gaps[11], this.botYval);

    cPoints5[3].setPosition(this.midpoints[11] + this.gaps[11], this.botYval);

    this.C6 = this.add
      .rexQuadImage(417.13, this.topYval, gameState.qnum + '_6', null, {
        hideCCW: false,
        rtl: true,
      })
      .setDepth(4)
      .setAlpha(0);

    //this.C1.setTexture('A_1_5')
    cPoints6 = this.C6.controlPoints;
    cPoints6[0].setPosition(this.midpoints[12] - this.gaps[12], this.topYval);

    cPoints6[1].setPosition(this.midpoints[12] + this.gaps[12], this.topYval);

    cPoints6[2].setPosition(this.midpoints[13] - this.gaps[13], this.botYval);

    cPoints6[3].setPosition(this.midpoints[13] + this.gaps[13], this.botYval);

    //  this.midpoints = [ (cPoints[0].x+cPoints[1].x)/2 ,(cPoints[2].x+cPoints[3].x)/2,
    //  (cPoints1[0].x+cPoints1[1].x)/2 ,(cPoints1[2].x+cPoints1[3].x)/2,
    //  (cPoints2[0].x+cPoints2[1].x)/2 ,(cPoints2[2].x+cPoints2[3].x)/2,
    //  (cPoints3[0].x+cPoints3[1].x)/2 ,(cPoints3[2].x+cPoints3[3].x)/2,
    //  (cPoints4[0].x+cPoints4[1].x)/2 ,(cPoints4[2].x+cPoints4[3].x)/2,
    //  (cPoints5[0].x+cPoints5[1].x)/2 ,(cPoints5[2].x+cPoints5[3].x)/2,
    //  (cPoints6[0].x+cPoints6[1].x)/2 ,(cPoints6[2].x+cPoints6[3].x)/2,
    //   ]

    // this.midpoints = [363.065, 338.255, 455.87, 438.62, 549.62, 540.12, 643.37, 642.12, 736.87, 744.12, 830.12, 845.37, 925.12, 949.87]
    //   console.log(this.midpoints)

    //  this.gaps = [ (-cPoints[0].x+cPoints[1].x)/2 ,(-cPoints[2].x+cPoints[3].x)/2,
    //   (-cPoints1[0].x+cPoints1[1].x)/2 ,(-cPoints1[2].x+cPoints1[3].x)/2,
    //   (-cPoints2[0].x+cPoints2[1].x)/2 ,(-cPoints2[2].x+cPoints2[3].x)/2,
    //   (-cPoints3[0].x+cPoints3[1].x)/2 ,(-cPoints3[2].x+cPoints3[3].x)/2,
    //   (-cPoints4[0].x+cPoints4[1].x)/2 ,(-cPoints4[2].x+cPoints4[3].x)/2,
    //   (-cPoints5[0].x+cPoints5[1].x)/2 ,(-cPoints5[2].x+cPoints5[3].x)/2,
    //   (-cPoints6[0].x+cPoints6[1].x)/2 ,(-cPoints6[2].x+cPoints6[3].x)/2,
    //    ]

    //    console.log(this.gaps)

    //this.gaps = [46.44499999999999, 50.254999999999995, 46.25, 50, 47, 51, 46.75, 51, 47.25, 51.5, 47.5, 51.25, 47.5, 53.25]
    //this.C2 = this.add.text(332.34+ 20 +2*96.27, 492+30, "-3", { fontFamily: "font1", fontSize: "33.65px", fill: "#000000" }).setOrigin(0.5, 0.5).setDepth(6).setAngle(3.2*(1/3)).setAlpha(0);
    // this.C3 = this.add.text(332.34+ 20 +3*96.27, 492+30, "-2", { fontFamily: "font1", fontSize: "33.65px", fill: "#000000" }).setOrigin(0.5, 0.5).setDepth(6).setAngle(3.2*(0/3)).setAlpha(0);
    // this.C4 = this.add.text(332.34+ 25 +4*96.27, 492+30, "0", { fontFamily: "font1", fontSize: "33.65px", fill: "#000000" }).setOrigin(0.5, 0.5).setDepth(6).setAngle(-3.2*(1/3)).setAlpha(0);
    // this.C5 = this.add.text(332.34+ 25 +5*96.27, 492+30, "1", { fontFamily: "font1", fontSize: "33.65px", fill: "#000000" }).setOrigin(0.5, 0.5).setDepth(6).setAngle(-3.2*(2/3)).setAlpha(0);

    bottomcards = [this.C1, this.C2, this.C3, this.C4, this.C5];

    this.tweens.add({
      targets: [this.L0, this.C0, this.L6, this.C6].filter(Boolean),
      alpha: 1,
      scale: 1,
      ease: 'sine.easeOut',
      duration: 1000,
      delay: 3000,
      //delay:this.cardDisplayDelay + 130*this.positions[i],
      repeat: 0,
      onStart: () => {
        this.cardp.play();
        this.overlay.setDepth(0);
        this.T1.setAlpha(0);
        this.box = this.add.image(288, 458, 'box').setOrigin(0).setDepth(3);
        //this.box.setDepth(3)
      },
    });

    const graphics = this.add.graphics();
    graphics.lineStyle(2, 0xffff00);
    graphics.strokeRect(
      zone_1.x - zone_1.input.hitArea.width / 2,
      zone_1.y - zone_1.input.hitArea.height / 2,
      zone_1.input.hitArea.width,
      zone_1.input.hitArea.height,
    );

    this.cardDisplayDelay = 1000;

    for (let i = 0; i <= 4; i++) {
      this.input.setDraggable(this.cards[i]);

      this.cards[i].disableInteractive();
      this.cards[i].on('pointerover', () => {
        if (this.cards[i].y < 400) {
          this.cards[i].y = this.cards[i].y - 10;
          this.cardhaudio.play();
        }
      });

      this.cards[i].on('pointerdown', () => {
        this.cards[i].setDepth(8);
      });

      this.cards[i].on('pointerout', () => {
        if (this.cards[i].y < 400) {
          this.cards[i].setDepth(1);
          this.cards[i].y = cardOrginals[2 * i + 1];
        } else {
          this.cards[i].setDepth(1);
        }
      });

      this.tweens.add({
        targets: this.cards[i],
        y: 330,
        ease: 'Power2',
        duration: 1000,
        delay: 3000 + this.cardDisplayDelay + 130 * this.positions[i],
        repeat: 0,
        onComplete: () => {
          // this.cards[0].setInteractive()
        },
      });
    }

    this.time.delayedCall(
      6000,
      () => {
        this.T2.setAlpha(1);
        this.T2audio = this.sound.add('T2audio').setVolume(0.1).play();

        if (gameState.retry == false) {
          this.load.multiatlas(
            'endConfetti',
            'assets/EndSceneAssets/confetti/confettiAnimNew.json',
            'assets/EndSceneAssets/confetti',
          );
          this.load.multiatlas(
            'spotlight',
            'assets/EndSceneAssets/spotlight/spotlightAnimNew.json',
            'assets/EndSceneAssets/spotlight',
          );

          this.load.start();
        }
      },
      this,
    );

    this.time.delayedCall(
      10000,
      () => {
        this.T2.setTexture('T3');
        this.T3audio = this.sound.add('T3audio').setVolume(0.1).play();
        card1.setInteractive();

        this.handMotion(420, 420, 330, 530);
      },
      this,
    );

    this.input.on('dragstart', function (pointer, gameObject, _dragX, _dragY) {
      gameObject.x = pointer.x;
      gameObject.y = pointer.y;

      if (gameObject.input.dragStartX <= 490 && gameObject.input.dragStartY >= 400) {
        bottomcards[0].setAlpha(0);
        Phaser.Utils.Array.AddAt(availables, 0, 0);
      } else if (
        gameObject.input.dragStartX <= 490 + 110 &&
        gameObject.input.dragStartY >= 400
      ) {
        bottomcards[1].setAlpha(0);
        Phaser.Utils.Array.AddAt(availables, 1, 1);
      } else if (
        gameObject.input.dragStartX <= 490 + 2 * 110 &&
        gameObject.input.dragStartY >= 400
      ) {
        bottomcards[2].setAlpha(0);
        Phaser.Utils.Array.AddAt(availables, 2, 2);
      } else if (
        gameObject.input.dragStartX < 490 + 3 * 110 &&
        gameObject.input.dragStartY >= 400
      ) {
        bottomcards[3].setAlpha(0);
        Phaser.Utils.Array.AddAt(availables, 3, 3);
      } else if (
        gameObject.input.dragStartX >= 490 + 3 * 110 &&
        gameObject.input.dragStartY >= 400
      ) {
        bottomcards[4].setAlpha(0);
        Phaser.Utils.Array.AddAt(availables, 4, 4);
      }

      if (gameObject == card1) {
        gameObject.setTexture(gameState.qnum + '_1');
      } else if (gameObject == card2) {
        gameObject.setTexture(gameState.qnum + '_2');
      } else if (gameObject == card3) {
        gameObject.setTexture(gameState.qnum + '_3');
      } else if (gameObject == card4) {
        gameObject.setTexture(gameState.qnum + '_4');
      } else if (gameObject == card5) {
        gameObject.setTexture(gameState.qnum + '_5');
      }
    });

    this.input.on('drag', function (pointer, gameObject, _dragX, _dragY) {
      gameObject.setDepth(7);
      gameObject.x = pointer.x;
      gameObject.y = pointer.y;
    });

    this.input.on(
      'dragend',
      (pointer, gameObject, dropped) => {
        if (!dropped) {
          if (gameObject == card1) {
            gameObject.x = cardOrginals[0];
            gameObject.y = cardOrginals[1];
          } else if (gameObject == card2) {
            gameObject.x = cardOrginals[2];
            gameObject.y = cardOrginals[3];
          } else if (gameObject == card3) {
            gameObject.x = cardOrginals[4];
            gameObject.y = cardOrginals[5];
          } else if (gameObject == card4) {
            gameObject.x = cardOrginals[6];
            gameObject.y = cardOrginals[7];
          } else if (gameObject == card5) {
            gameObject.x = cardOrginals[8];
            gameObject.y = cardOrginals[9];
          }

          gameObject.setDepth(1);
        } else {
          this.carddaudio.play();
          gameObject.setDepth(1);
          if (gameObject == card1) {
            cardvalue = seq[0];

            //       this.L1 = this.add.image(381-2,458-2,'L1').setOrigin(0).setDepth(2).setAlpha(0).setInteractive({ cursor: "pointer" })
          } else if (gameObject == card2) {
            cardvalue = seq[1];
          } else if (gameObject == card3) {
            cardvalue = seq[2];
          } else if (gameObject == card4) {
            cardvalue = seq[3];
          } else if (gameObject == card5) {
            cardvalue = seq[4];
          }

          if (gameState.qnum == -1) {
            if (gameObject == card1) {
              gameObject.x = 381 - 3 + 68.5;
              gameObject.y = 458 - 2 + 70.5;
              cardDrop = 0;
              gameObject.disableInteractive();
              card2.setInteractive();

              hand.destroy();

              this.handMotion(530, 540, 330, 530);
            } else if (gameObject == card2) {
              gameObject.x = 381 - 2 + 68.5;
              gameObject.y = 458 - 2 + 70.5;
              cardDrop = 1;
              gameObject.disableInteractive();
              card3.setInteractive();

              hand.destroy();

              this.handMotion(640, 640, 330, 530);
            } else if (gameObject == card3) {
              gameObject.x = 381 - 1 + 68.5;
              gameObject.y = 458 - 2 + 70.5;
              cardDrop = 2;
              gameObject.disableInteractive();
              card4.setInteractive();

              hand.destroy();

              this.handMotion(740, 730, 330, 530);
            } else if (gameObject == card4) {
              gameObject.x = 381 + 68.5;
              gameObject.y = 458 - 2 + 70.5;
              cardDrop = 3;
              gameObject.disableInteractive();
              card5.setInteractive();

              hand.destroy();

              this.handMotion(840, 830, 330, 530);
            } else if (gameObject == card5) {
              gameObject.x = 754 + 86;
              gameObject.y = 458 - 2 + 70.5;
              cardDrop = 4;
              gameObject.disableInteractive();
              //this.T2.setAlpha(0);
              //this.T2.setTexture("T5");
              //this.T5audio = this.sound.add("T5audio").setVolume(0.1).play();
              hand.destroy();

              this.T4 = this.add.image(804, 631, 'T4').setOrigin(0, 0).setDepth(7); //.setAlpha(0)
              this.carrow = this.add.image(775, 625, 'arrow').setOrigin(0).setDepth(7);

              this.tweens.add({
                targets: this.carrow,
                x: {
                  getEnd: function () {
                    return 720;
                  },
                  getStart: function () {
                    return 745;
                  },
                },

                duration: 500,
                delay: 100,
                yoyo: true,
                repeat: -1,
                ease: 'Sine.easeInOut',
                onStart: () => {},
              });
            }
          } else {
            if (gameObject.x < 490) {
              //gameObject.setAlpha(0)
              if (availables.includes(0)) {
                gameObject.x = 381 - 3 + 68.5;
                gameObject.y = 458 - 2 + 70.5;
                gameObject.setTexture('L1').setInteractive({ pixelPerfect: true });
                cardDrop = 0;
              } else {
                if (gameObject == card1) {
                  gameObject.x = cardOrginals[0];
                  gameObject.y = cardOrginals[1];
                } else if (gameObject == card2) {
                  gameObject.x = cardOrginals[2];
                  gameObject.y = cardOrginals[3];
                } else if (gameObject == card3) {
                  gameObject.x = cardOrginals[4];
                  gameObject.y = cardOrginals[5];
                } else if (gameObject == card4) {
                  gameObject.x = cardOrginals[6];
                  gameObject.y = cardOrginals[7];
                } else if (gameObject == card5) {
                  gameObject.x = cardOrginals[8];
                  gameObject.y = cardOrginals[9];
                }

                gameObject.setDepth(1);
              }
            } else if (gameObject.x < 490 + 110) {
              if (availables.includes(1)) {
                gameObject.x = 476 - 5 + 73;
                gameObject.y = 458 - 2 + 70.5;
                gameObject.setTexture('L2').setInteractive({ pixelPerfect: true });

                cardDrop = 1;
              } else {
                if (gameObject == card1) {
                  gameObject.x = cardOrginals[0];
                  gameObject.y = cardOrginals[1];
                } else if (gameObject == card2) {
                  gameObject.x = cardOrginals[2];
                  gameObject.y = cardOrginals[3];
                } else if (gameObject == card3) {
                  gameObject.x = cardOrginals[4];
                  gameObject.y = cardOrginals[5];
                } else if (gameObject == card4) {
                  gameObject.x = cardOrginals[6];
                  gameObject.y = cardOrginals[7];
                } else if (gameObject == card5) {
                  gameObject.x = cardOrginals[8];
                  gameObject.y = cardOrginals[9];
                }

                gameObject.setDepth(1);
              }
            } else if (gameObject.x < 490 + 2 * 110) {
              if (availables.includes(2)) {
                gameObject.x = 568 - 2 + 77;
                gameObject.y = 458 - 2 + 70.5;
                gameObject.setTexture('L3').setInteractive({ pixelPerfect: true });

                cardDrop = 2;
              } else {
                if (gameObject == card1) {
                  gameObject.x = cardOrginals[0];
                  gameObject.y = cardOrginals[1];
                } else if (gameObject == card2) {
                  gameObject.x = cardOrginals[2];
                  gameObject.y = cardOrginals[3];
                } else if (gameObject == card3) {
                  gameObject.x = cardOrginals[4];
                  gameObject.y = cardOrginals[5];
                } else if (gameObject == card4) {
                  gameObject.x = cardOrginals[6];
                  gameObject.y = cardOrginals[7];
                } else if (gameObject == card5) {
                  gameObject.x = cardOrginals[8];
                  gameObject.y = cardOrginals[9];
                }

                gameObject.setDepth(1);
              }
            } else if (gameObject.x < 490 + 3 * 110) {
              if (availables.includes(3)) {
                gameObject.x = 661 - 1 + 82;
                gameObject.y = 458 - 2 + 70.5;
                gameObject.setTexture('L4').setInteractive({ pixelPerfect: true });

                cardDrop = 3;
              } else {
                if (gameObject == card1) {
                  gameObject.x = cardOrginals[0];
                  gameObject.y = cardOrginals[1];
                } else if (gameObject == card2) {
                  gameObject.x = cardOrginals[2];
                  gameObject.y = cardOrginals[3];
                } else if (gameObject == card3) {
                  gameObject.x = cardOrginals[4];
                  gameObject.y = cardOrginals[5];
                } else if (gameObject == card4) {
                  gameObject.x = cardOrginals[6];
                  gameObject.y = cardOrginals[7];
                } else if (gameObject == card5) {
                  gameObject.x = cardOrginals[8];
                  gameObject.y = cardOrginals[9];
                }

                gameObject.setDepth(1);
              }
            } else if (gameObject.x >= 490 + 3 * 110) {
              if (availables.includes(4)) {
                gameObject.x = 754 + 86;
                gameObject.y = 458 - 2 + 70.5;
                gameObject.setTexture('L5').setInteractive({ pixelPerfect: true });

                cardDrop = 4;
              } else {
                if (gameObject == card1) {
                  gameObject.x = cardOrginals[0];
                  gameObject.y = cardOrginals[1];
                } else if (gameObject == card2) {
                  gameObject.x = cardOrginals[2];
                  gameObject.y = cardOrginals[3];
                } else if (gameObject == card3) {
                  gameObject.x = cardOrginals[4];
                  gameObject.y = cardOrginals[5];
                } else if (gameObject == card4) {
                  gameObject.x = cardOrginals[6];
                  gameObject.y = cardOrginals[7];
                } else if (gameObject == card5) {
                  gameObject.x = cardOrginals[8];
                  gameObject.y = cardOrginals[9];
                }

                gameObject.setDepth(1);
              }
            }
          }
        }
      },
      this,
    );

    this.input.on('drop', function (_pointer, _gameObject, _dropZone) {});
  }

  flipping(target, item, time, midpoint, gap, val) {
    this.tweens.add({
      targets: [target[0], target[1]],
      x: this.midpoints[midpoint],
      ease: 'sine.easeOut',
      duration: 500,
      delay: time,
      repeat: 0,
      onStart: () => {},
      onComplete: () => {
        item.setTexture('A_' + gameState.correct + '_' + val);

        this.tweens.add({
          targets: target[0],
          x: this.midpoints[midpoint] - this.gaps[gap],
          ease: 'sine.easeOut',
          duration: 500,
          repeat: 0,
          onComplete: () => {},
        });

        this.tweens.add({
          targets: target[1],
          x: this.midpoints[midpoint] + this.gaps[gap],
          ease: 'sine.easeOut',
          duration: 500,
          repeat: 0,
          onComplete: () => {},
        });

        this.tweens.add({
          targets: target[2],
          x: this.midpoints[midpoint + 1] - this.gaps[gap + 1],
          ease: 'sine.easeOut',
          duration: 500,
          repeat: 0,
          onComplete: () => {},
        });

        this.tweens.add({
          targets: target[3],
          x: this.midpoints[midpoint + 1] + this.gaps[gap + 1],
          ease: 'sine.easeOut',
          duration: 500,
          repeat: 0,
          onComplete: () => {},
        });
      },
    });

    this.tweens.add({
      targets: [target[2], target[3]],

      x: this.midpoints[midpoint + 1],
      ease: 'sine.easeOut',
      duration: 500,
      delay: time,
      repeat: 0,
      onComplete: () => {},
    });
  }

  nextquestions() {
    this.pushbutton.setDepth(6);
    this.stick.setDepth(6);
    this.vid.changeSource('drivein');
    this.vid.setAlpha(1);
    this.positions = [0, 1, 2, 3, 4];
    Phaser.Utils.Array.Shuffle(this.positions);

    availables = [0, 1, 2, 3, 4];
    seq = [-5, -3, -2, 0, 1];

    card5 = this.add
      .sprite(429 + 106 * this.positions[4], 330 + 300, gameState.qnum + '_5')
      .setInteractive({ cursor: 'pointer', pixelPerfect: true });

    card4 = this.add
      .sprite(429 + 106 * this.positions[3], 330 + 300, gameState.qnum + '_4')
      .setInteractive({ cursor: 'pointer', pixelPerfect: true });

    card3 = this.add
      .sprite(429 + 106 * this.positions[2], 330 + 300, gameState.qnum + '_3')
      .setInteractive({ cursor: 'pointer', pixelPerfect: true });

    card2 = this.add
      .sprite(429 + 106 * this.positions[1], 330 + 300, gameState.qnum + '_2')
      .setInteractive({ cursor: 'pointer', pixelPerfect: true });

    card1 = this.add
      .sprite(429 + 106 * this.positions[0], 330 + 300, gameState.qnum + '_1')
      .setInteractive({ cursor: 'pointer', pixelPerfect: true });

    cardOrginals = [
      card1.x,
      card1.y - 300,
      card2.x,
      card2.y - 300,
      card3.x,
      card3.y - 300,
      card4.x,
      card4.y - 300,
      card5.x,
      card5.y - 300,
    ];

    this.cards = [card1, card2, card3, card4, card5];

    //console.log(card1.controlPoints);

    //   this.input.setDraggable(card1)

    this.shipOverlay = this.add
      .image(0, 0, 'ship')
      .setOrigin(0)
      .setCrop(0, 394.5, 1280, 720 - 394.5)
      .setDepth(2);

    //this.L0 = this.add.image(288-2 + 66,458-2+70.5 ,'L0').setOrigin(0.5).setDepth(2).setAlpha(0).setScale(0)
    this.L1 = this.add
      .image(381 - 2, 458 - 2, 'L1')
      .setOrigin(0)
      .setDepth(2)
      .setAlpha(0)
      .setInteractive({ cursor: 'pointer', pixelPerfect: true });
    this.L2 = this.add
      .image(474 - 2, 458 - 2, 'L2')
      .setOrigin(0)
      .setDepth(2)
      .setAlpha(0)
      .setInteractive({ cursor: 'pointer', pixelPerfect: true });
    this.L3 = this.add
      .image(568 - 2, 458 - 2, 'L3')
      .setOrigin(0)
      .setDepth(2)
      .setAlpha(0)
      .setInteractive({ cursor: 'pointer', pixelPerfect: true });
    this.L4 = this.add
      .image(661 - 2, 458 - 2, 'L4')
      .setOrigin(0)
      .setDepth(2)
      .setAlpha(0)
      .setInteractive({ cursor: 'pointer', pixelPerfect: true });
    this.L5 = this.add
      .image(754 - 1, 458 - 2, 'L5')
      .setOrigin(0)
      .setDepth(2)
      .setAlpha(0)
      .setInteractive({ cursor: 'pointer', pixelPerfect: true });
    //this.L6 = this.add.image(849+91.5,458-2+70.5,'L6').setOrigin(0.5).setDepth(2).setAlpha(0).setScale(0)

    //   this.C0 = this.add.text(332.34+ 20, 492+30, "-7", { fontFamily: "font1", fontSize: "33.65px", fill: "#000000" }).setOrigin(0.5, 0.5).setDepth(3).setAngle(3.2).setAlpha(0).setScale(0);
    //   this.C1 = this.add.text(332.34+ 18 +96.27, 492+30, "-5", { fontFamily: "font1", fontSize: "33.65px", fill: "#000000" }).setOrigin(0.5, 0.5).setDepth(6).setAngle(3.2*(2/3)).setAlpha(0);
    //   this.C2 = this.add.text(332.34+ 20 +2*96.27, 492+30, "-3", { fontFamily: "font1", fontSize: "33.65px", fill: "#000000" }).setOrigin(0.5, 0.5).setDepth(6).setAngle(3.2*(1/3)).setAlpha(0);
    //   this.C3 = this.add.text(332.34+ 20 +3*96.27, 492+30, "-2", { fontFamily: "font1", fontSize: "33.65px", fill: "#000000" }).setOrigin(0.5, 0.5).setDepth(6).setAngle(3.2*(0/3)).setAlpha(0);
    //   this.C4 = this.add.text(332.34+ 25 +4*96.27, 492+30, "0", { fontFamily: "font1", fontSize: "33.65px", fill: "#000000" }).setOrigin(0.5, 0.5).setDepth(6).setAngle(-3.2*(1/3)).setAlpha(0);
    //   this.C5 = this.add.text(332.34+ 25 +5*96.27, 492+30, "1", { fontFamily: "font1", fontSize: "33.65px", fill: "#000000" }).setOrigin(0.5, 0.5).setDepth(6).setAngle(-3.2*(2/3)).setAlpha(0);
    //   this.C6 = this.add.text(910+ 30, 492+30, "2", { fontFamily: "font1", fontSize: "33.65px", fill: "#000000" }).setOrigin(0.5, 0.5).setDepth(3).setAngle(-3.2).setAlpha(0).setScale(0);

    //   this.C1 = this.add.rexQuadImage(x, y, "A_1_1", null, {hideCCW: false,rtl: true,})

    this.midpoints = [
      363.065, 338.255, 455.87, 438.62, 549.62, 540.12, 643.37, 642.12, 736.87, 744.12,
      830.12, 845.37, 925.12, 949.87,
    ];

    this.gaps = [
      47.5,
      51,
      46.25 + 1,
      50 + 1,
      47 + 1,
      51 + 1,
      46.75 + 1,
      51 + 1,
      47.25,
      51.5,
      47.5,
      51.25,
      47.5 + 1.5,
      53.25 + 1.5,
    ];

    this.topYval = 455; //457
    //this.botYval = 594.52
    this.botYval = 597.52;
    this.C0 = this.add
      .rexQuadImage(417.13, this.topYval, gameState.qnum + '_0', null, {
        hideCCW: false,
        rtl: true,
      })
      .setDepth(3)
      .setAlpha(0);

    cPoints = this.C0.controlPoints;
    cPoints[0].setPosition(this.midpoints[0] - this.gaps[0], this.topYval);

    cPoints[1].setPosition(this.midpoints[0] + this.gaps[0], this.topYval);

    cPoints[2].setPosition(this.midpoints[1] - this.gaps[1], this.botYval);

    cPoints[3].setPosition(this.midpoints[1] + this.gaps[1], this.botYval);

    this.C1 = this.add
      .rexQuadImage(417.13, this.topYval, gameState.qnum + '_1', null, {
        hideCCW: false,
        rtl: true,
      })
      .setDepth(3)
      .setAlpha(0);

    //this.C1.setTexture('A_1_5')
    cPoints1 = this.C1.controlPoints;
    cPoints1[0].setPosition(this.midpoints[2] - this.gaps[2], this.topYval);

    cPoints1[1].setPosition(this.midpoints[2] + this.gaps[2], this.topYval);

    cPoints1[2].setPosition(this.midpoints[3] - this.gaps[3], this.botYval);

    cPoints1[3].setPosition(this.midpoints[3] + this.gaps[3], this.botYval);

    this.C2 = this.add
      .rexQuadImage(417.13, this.topYval, gameState.qnum + '_1', null, {
        hideCCW: false,
        rtl: true,
      })
      .setDepth(3)
      .setAlpha(0);

    //this.C1.setTexture('A_1_5')
    cPoints2 = this.C2.controlPoints;
    cPoints2[0].setPosition(this.midpoints[4] - this.gaps[4], this.topYval);

    cPoints2[1].setPosition(this.midpoints[4] + this.gaps[4], this.topYval);

    cPoints2[2].setPosition(this.midpoints[5] - this.gaps[5], this.botYval);

    cPoints2[3].setPosition(this.midpoints[5] + this.gaps[5], this.botYval);

    this.C3 = this.add
      .rexQuadImage(417.13, this.topYval, gameState.qnum + '_1', null, {
        hideCCW: false,
        rtl: true,
      })
      .setDepth(3)
      .setAlpha(0);

    //this.C1.setTexture('A_1_5')
    cPoints3 = this.C3.controlPoints;

    cPoints3[0].setPosition(this.midpoints[6] - this.gaps[6], this.topYval);

    cPoints3[1].setPosition(this.midpoints[6] + this.gaps[6], this.topYval);

    cPoints3[2].setPosition(this.midpoints[7] - this.gaps[7], this.botYval);

    cPoints3[3].setPosition(this.midpoints[7] + this.gaps[7], this.botYval);

    this.C4 = this.add
      .rexQuadImage(417.13, this.topYval, gameState.qnum + '_1', null, {
        hideCCW: false,
        rtl: true,
      })
      .setDepth(3)
      .setAlpha(0);

    //this.C1.setTexture('A_1_5')
    cPoints4 = this.C4.controlPoints;

    cPoints4[0].setPosition(this.midpoints[8] - this.gaps[8], this.topYval);

    cPoints4[1].setPosition(this.midpoints[8] + this.gaps[8], this.topYval);

    cPoints4[2].setPosition(this.midpoints[9] - this.gaps[9], this.botYval);

    cPoints4[3].setPosition(this.midpoints[9] + this.gaps[9], this.botYval);

    this.C5 = this.add
      .rexQuadImage(417.13, this.topYval, gameState.qnum + '_1', null, {
        hideCCW: false,
        rtl: true,
      })
      .setDepth(3)
      .setAlpha(0);

    //this.C1.setTexture('A_1_5')
    cPoints5 = this.C5.controlPoints;
    cPoints5[0].setPosition(this.midpoints[10] - this.gaps[10], this.topYval);

    cPoints5[1].setPosition(this.midpoints[10] + this.gaps[10], this.topYval);

    cPoints5[2].setPosition(this.midpoints[11] - this.gaps[11], this.botYval);

    cPoints5[3].setPosition(this.midpoints[11] + this.gaps[11], this.botYval);

    this.C6 = this.add
      .rexQuadImage(417.13, this.topYval, gameState.qnum + '_6', null, {
        hideCCW: false,
        rtl: true,
      })
      .setDepth(3)
      .setAlpha(0);

    //this.C1.setTexture('A_1_5')
    cPoints6 = this.C6.controlPoints;
    cPoints6[0].setPosition(this.midpoints[12] - this.gaps[12], this.topYval);

    cPoints6[1].setPosition(this.midpoints[12] + this.gaps[12], this.topYval);

    cPoints6[2].setPosition(this.midpoints[13] - this.gaps[13], this.botYval);

    cPoints6[3].setPosition(this.midpoints[13] + this.gaps[13], this.botYval);

    //  this.midpoints = [ (cPoints[0].x+cPoints[1].x)/2 ,(cPoints[2].x+cPoints[3].x)/2,
    //  (cPoints1[0].x+cPoints1[1].x)/2 ,(cPoints1[2].x+cPoints1[3].x)/2,
    //  (cPoints2[0].x+cPoints2[1].x)/2 ,(cPoints2[2].x+cPoints2[3].x)/2,
    //  (cPoints3[0].x+cPoints3[1].x)/2 ,(cPoints3[2].x+cPoints3[3].x)/2,
    //  (cPoints4[0].x+cPoints4[1].x)/2 ,(cPoints4[2].x+cPoints4[3].x)/2,
    //  (cPoints5[0].x+cPoints5[1].x)/2 ,(cPoints5[2].x+cPoints5[3].x)/2,
    //  (cPoints6[0].x+cPoints6[1].x)/2 ,(cPoints6[2].x+cPoints6[3].x)/2,
    //   ]

    // this.midpoints = [363.065, 338.255, 455.87, 438.62, 549.62, 540.12, 643.37, 642.12, 736.87, 744.12, 830.12, 845.37, 925.12, 949.87]
    //   console.log(this.midpoints)

    //  this.gaps = [ (-cPoints[0].x+cPoints[1].x)/2 ,(-cPoints[2].x+cPoints[3].x)/2,
    //   (-cPoints1[0].x+cPoints1[1].x)/2 ,(-cPoints1[2].x+cPoints1[3].x)/2,
    //   (-cPoints2[0].x+cPoints2[1].x)/2 ,(-cPoints2[2].x+cPoints2[3].x)/2,
    //   (-cPoints3[0].x+cPoints3[1].x)/2 ,(-cPoints3[2].x+cPoints3[3].x)/2,
    //   (-cPoints4[0].x+cPoints4[1].x)/2 ,(-cPoints4[2].x+cPoints4[3].x)/2,
    //   (-cPoints5[0].x+cPoints5[1].x)/2 ,(-cPoints5[2].x+cPoints5[3].x)/2,
    //   (-cPoints6[0].x+cPoints6[1].x)/2 ,(-cPoints6[2].x+cPoints6[3].x)/2,
    //    ]

    //    console.log(this.gaps)

    //this.gaps = [46.44499999999999, 50.254999999999995, 46.25, 50, 47, 51, 46.75, 51, 47.25, 51.5, 47.5, 51.25, 47.5, 53.25]
    //this.C2 = this.add.text(332.34+ 20 +2*96.27, 492+30, "-3", { fontFamily: "font1", fontSize: "33.65px", fill: "#000000" }).setOrigin(0.5, 0.5).setDepth(6).setAngle(3.2*(1/3)).setAlpha(0);
    // this.C3 = this.add.text(332.34+ 20 +3*96.27, 492+30, "-2", { fontFamily: "font1", fontSize: "33.65px", fill: "#000000" }).setOrigin(0.5, 0.5).setDepth(6).setAngle(3.2*(0/3)).setAlpha(0);
    // this.C4 = this.add.text(332.34+ 25 +4*96.27, 492+30, "0", { fontFamily: "font1", fontSize: "33.65px", fill: "#000000" }).setOrigin(0.5, 0.5).setDepth(6).setAngle(-3.2*(1/3)).setAlpha(0);
    // this.C5 = this.add.text(332.34+ 25 +5*96.27, 492+30, "1", { fontFamily: "font1", fontSize: "33.65px", fill: "#000000" }).setOrigin(0.5, 0.5).setDepth(6).setAngle(-3.2*(2/3)).setAlpha(0);

    bottomcards = [this.C1, this.C2, this.C3, this.C4, this.C5];

    this.tweens.add({
      targets: [this.L0, this.C0, this.L6, this.C6].filter(Boolean),
      alpha: 1,
      scale: 1,
      ease: 'sine.easeOut',
      duration: 1000,
      //delay:this.cardDisplayDelay + 130*this.positions[i],
      repeat: 0,
      onStart: () => {
        this.cardp.play();
      },
    });

    const graphics = this.add.graphics();
    graphics.lineStyle(2, 0xffff00);
    graphics.strokeRect(
      zone_1.x - zone_1.input.hitArea.width / 2,
      zone_1.y - zone_1.input.hitArea.height / 2,
      zone_1.input.hitArea.width,
      zone_1.input.hitArea.height,
    );

    this.cardDisplayDelay = 1000;

    for (let i = 0; i <= 4; i++) {
      this.input.setDraggable(this.cards[i]);

      this.cards[i].disableInteractive();
      this.cards[i].on('pointerover', () => {
        if (this.cards[i].y < 400) {
          this.cards[i].y = this.cards[i].y - 10;
          this.cardhaudio.play();
        }
      });

      this.cards[i].on('pointerdown', () => {
        this.cards[i].setDepth(8);
      });

      this.cards[i].on('pointerout', () => {
        if (this.cards[i].y < 400) {
          this.cards[i].setDepth(1);
          this.cards[i].y = cardOrginals[2 * i + 1];
        } else {
          this.cards[i].setDepth(1);
        }
      });

      this.tweens.add({
        targets: this.cards[i],
        y: 330,
        ease: 'Power2',
        duration: 1000,
        delay: this.cardDisplayDelay + 130 * this.positions[i],
        repeat: 0,
        onComplete: () => {
          this.cards[i].setInteractive();
        },
      });
    }
  }

  handMotion(x1, x2, y1, y2) {
    hand = this.add.image(x1, y1, 'hand').setOrigin(0).setDepth(7);

    this.tweens.add({
      targets: hand,
      x: {
        getEnd: function () {
          return x2;
        },
        getStart: function () {
          return x1;
        },
      },

      y: {
        getEnd: function () {
          return y2;
        },
        getStart: function () {
          return y1;
        },
      },
      duration: 1000,
      yoyo: true,
      repeat: -1,
      ease: 'Sine.easeInOut',
      onStart: () => {},
    });
  }

  update() {
    //console.log(this.D1, this.D2, this.D3, this.D4, this.D5);

    if (this.checktest && availables.length > 0) {
      this.checktest = false;
      this.tweens.add({
        targets: this.check,
        y: 916,
        ease: 'Power2',
        duration: 500,
        repeat: 0,
      });
    }

    if (cardDrop > -1) {
      Phaser.Utils.Array.Remove(availables, cardDrop);

      if (availables.length == 0) {
        this.tweens.add({
          targets: this.check,
          y: 616,
          ease: 'Power2',
          duration: 500,
          repeat: 0,
          onComplete: () => {
            this.checktest = true;
          },
        });
      }
      this.cardnum = seq.indexOf(cardvalue);

      if (cardDrop == 0) {
        this.C1.setTexture(gameState.qnum + '_' + (this.cardnum + 1));
        this.C1.setAlpha(1);

        this.D1 = this.cardnum;

        //  this.L1.setAlpha(1)
      } else if (cardDrop == 1) {
        this.C2.setTexture(gameState.qnum + '_' + (this.cardnum + 1));
        this.C2.setAlpha(1);
        this.D2 = this.cardnum;
        // this.L2.setAlpha(1)
      } else if (cardDrop == 2) {
        this.C3.setTexture(gameState.qnum + '_' + (this.cardnum + 1));
        this.C3.setAlpha(1);

        this.D3 = this.cardnum;

        //  this.L3.setAlpha(1)
      } else if (cardDrop == 3) {
        this.C4.setTexture(gameState.qnum + '_' + (this.cardnum + 1));
        this.C4.setAlpha(1);

        this.D4 = this.cardnum;
        //  this.L4.setAlpha(1)
      } else if (cardDrop == 4) {
        this.C5.setTexture(gameState.qnum + '_' + (this.cardnum + 1));
        this.C5.setAlpha(1);

        this.D5 = this.cardnum;

        //  this.L5.setAlpha(1)
      }

      cardDrop = -1;
    }
  }
}
